import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "filters d-flex flex-column flex-row@sm mb-xl" }
const _hoisted_2 = {
  key: 2,
  class: "text-sm py-4xl op-70"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_4 = {
  key: 3,
  class: "text-3xl mb-5xl"
}
const _hoisted_5 = {
  ref: "endOfPageRef",
  height: "1px"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_ButtonText = _resolveComponent("ButtonText")!
  const _component_DropdownChevronIcon = _resolveComponent("DropdownChevronIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DropdownListGroup = _resolveComponent("DropdownListGroup")!
  const _component_PosterCard = _resolveComponent("PosterCard")!
  const _component_Col = _resolveComponent("Col")!
  const _component_Row = _resolveComponent("Row")!
  const _component_PosterCardSkeleton = _resolveComponent("PosterCardSkeleton")!
  const _component_Grid = _resolveComponent("Grid")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Grid, { size: "xl" }, {
      default: _withCtx(() => [
        _createVNode(_component_PageTitle, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.trans("general.cinema_release_calendar")), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_DropdownListGroup, {
            isOpen: _ctx.isOpenFilterMediaDates,
            "onUpdate:isOpen": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isOpenFilterMediaDates) = $event)),
            selectedOptionValue: _ctx.filterDate,
            "onUpdate:selectedOptionValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterDate) = $event)),
            options: _ctx.mediaDatesOptions
          }, {
            trigger: _withCtx(({ attributes, listeners, selectedOptionName }) => [
              _createElementVNode("div", _mergeProps({ class: "d-flex align-items-center color-accent-base cursor-pointer" }, attributes, _toHandlers(listeners)), [
                _createVNode(_component_Button, {
                  size: "lg",
                  class: "w-full w-auto@sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ButtonText, {
                      class: "text-lg mr-2",
                      variants: ['base']
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.trans("general.date")) + ": " + _toDisplayString(selectedOptionName), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_DropdownChevronIcon, { as: _ctx.ButtonIcon }, null, 8, ["as"])
                  ]),
                  _: 2
                }, 1024)
              ], 16)
            ]),
            _: 1
          }, 8, ["isOpen", "selectedOptionValue", "options"])
        ]),
        (_ctx.medias.length)
          ? (_openBlock(), _createBlock(_component_Row, {
              key: 0,
              class: "mb-xl",
              gap: "lg"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medias, (media) => {
                  return (_openBlock(), _createBlock(_component_Col, {
                    key: media._id,
                    size: ['1/2', '1/3@sm', '1/4@md', '1/5@xl']
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_PosterCard, { media: media }, null, 8, ["media"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.requestStateMedias.status === 'loading')
          ? (_openBlock(), _createBlock(_component_Row, {
              key: 1,
              gap: "lg"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.LIMIT, (n) => {
                  return (_openBlock(), _createBlock(_component_Col, {
                    key: 'poster-card-skeleton-' + n,
                    size: ['1/2', '1/3@sm', '1/4@md', '1/5@xl']
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_PosterCardSkeleton)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.medias.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.trans("general.release_dates_are_subject_to_change")), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.requestStateMedias.status === 'ready' && !_ctx.medias.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.trans("premieres.no_results_were_found_for_this_search")), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, null, 512)
      ]),
      _: 1
    })
  ]))
}